/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cloud_logic_custom": [
        {
            "name": "buckluckyapi1",
            "endpoint": "https://eggk7hz3w1.execute-api.us-east-1.amazonaws.com/dev",
            "region": "us-east-1"
        }
    ],
    "aws_cognito_identity_pool_id": "us-east-1:b07c0229-3c2a-484c-9554-211adee30a1b",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_5QW6Gvhkx",
    "aws_user_pools_web_client_id": "1uetdegg91lvd4hs1bccf8jfe5",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_dynamodb_all_tables_region": "us-east-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "buckluckydynamodb1-dev",
            "region": "us-east-1"
        }
    ],
    "aws_user_files_s3_bucket": "oddscachebucklucky57112838-dev",
    "aws_user_files_s3_bucket_region": "us-east-1"
};


export default awsmobile;
